import React, { useEffect } from "react";
import { useSnackbar, SnackbarKey, VariantType } from "notistack";

// Define the interface for the inner configurator
interface InnerSnackbarUtilsConfiguratorProps {
  setUseSnackbarRef: (enqueue: ReturnType<typeof useSnackbar>) => void;
}

// Internal component to grab snackbar methods
const InnerSnackbarUtilsConfigurator: React.FC<
  InnerSnackbarUtilsConfiguratorProps
> = ({ setUseSnackbarRef }) => {
  const snackbar = useSnackbar();

  useEffect(() => {
    setUseSnackbarRef(snackbar);
  }, [snackbar, setUseSnackbarRef]);

  return null;
};

// Module-scoped snackbar reference
let snackbarRef: ReturnType<typeof useSnackbar>;

const setUseSnackbarRef = (ref: ReturnType<typeof useSnackbar>) => {
  snackbarRef = ref;
};

// Configurator component to include in your app root
export const SnackbarUtilsConfigurator: React.FC = () => {
  return (
    <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
  );
};

// Snack actions
export const snackActions = {
  success(msg: string) {
    this.toast(msg, "success");
  },
  warning(msg: string) {
    this.toast(msg, "warning");
  },
  info(msg: string) {
    this.toast(msg, "info");
  },
  error(msg: string) {
    this.toast(msg, "error");
  },
  closeSnackbar(key: SnackbarKey) {
    snackbarRef.closeSnackbar(key);
  },
  toast(msg: string, variant: VariantType = "default") {
    snackbarRef.enqueueSnackbar(msg, { variant });
  },
};
